import constants from '../constants';
import getIconDialogCommonTraits from '../helpers/get-icon-dialog-common-traits';
import trackEvent from './track-event';

const { events } = constants;

export default function trackSelectIconErrorLoadingIcons({
  dialogId,
  targetElementId,
  tabId,
  premiumAvailable,
}) {
  const traits = {
    dialogId,
    premiumAvailable,
    tabId,
    ...getIconDialogCommonTraits(targetElementId),
  };

  trackEvent(events.SELECT_ICON_ERROR_LOADING_ICONS, traits);
}
